// Fallback permission catalog — mirrors backend/constants/permissionCatalog.js.
// The Roles & Access editor normally fetches the live catalog from
// GET /api/roles/permissions/catalog; this is only used if that request fails.
const permissionsData = [
  {
    module: "General Access",
    icon: "home",
    items: [
      { name: "Dashboard", key: "view_dashboard", description: "View dashboard and analytics" },
      { name: "Settings", key: "view_settings", description: "Open the Settings area" },
    ],
  },
  {
    module: "People & Organisation",
    icon: "user",
    items: [
      { name: "View Employees", key: "view_employees", description: "View the employee directory and profiles" },
      { name: "Manage Employees", key: "manage_employees", description: "Create, edit and remove employees" },
      { name: "View Organisation Chart", key: "view_org_chart", description: "View reporting structures" },
      { name: "Manage Organisation Chart", key: "manage_org_chart", description: "Assign managers and run mass transfers" },
      { name: "Exit Information", key: "view_exit_information", description: "See the Exit tab on an employee record — resignation date, last working day, notice period, reason for exit and exit interview notes" },
    ],
  },
  {
    module: "Attendance & Leave",
    icon: "clock",
    items: [
      { name: "View Attendance", key: "view_attendance", description: "Open the attendance module" },
      { name: "Mark Attendance", key: "mark_attendance", description: "Clock in / out and take breaks" },
      { name: "Manage Attendance", key: "manage_attendance", description: "View company attendance and approve regularisations" },
      { name: "View Leaves", key: "view_leaves", description: "Open the leave management module" },
      { name: "Apply for Leave", key: "apply_leave", description: "Submit and withdraw leave requests" },
      { name: "Approve Leaves", key: "manage_leaves", description: "Approve or reject leave requests submitted by all employees." },
      { name: "Approve Team Leaves", key: "approve_team_leaves", description: "Approve or reject leave requests submitted by all employees. from your team- the people who report to you and the people on the projects you manage" },
      { name: "Approve Team Regularisations", key: "approve_team_regularisation", description: "Approve or reject attendance regularisation requests from your team - the people who report to you and the people on the projects you manage" },
    ],
  },
  {
    module: "Scheduling",
    icon: "calendar",
    items: [
      { name: "View Calendar", key: "view_calendar", description: "Open the calendar" },
      { name: "View Team Leaves on Calendar", key: "view_team_leaves_calendar", description: "See your team members' approved leaves on the calendar, so you can track who is away and when" },
      { name: "View Shifts", key: "view_shifts", description: "Open the shift planner" },
      { name: "Manage Shifts", key: "manage_shifts", description: "Assign, bulk-assign and approve shift swaps" },
    ],
  },
  {
    module: "Workspace",
    icon: "folder",
    items: [
      { name: "View Workspace", key: "view_workspace", description: "Open projects and tasks" },
      { name: "Log Time", key: "log_time", description: "Track time against tasks" },
      { name: "Manage Projects", key: "manage_projects", description: "Create and edit projects, including adding people to a project. Does not allow deleting a project." },
      { name: "Delete Projects", key: "delete_projects", description: "Permanently delete a project, along with its tasks and logged time" },
      { name: "Manage Clients", key: "manage_clients", description: "Manage clients and pricing models" },
      { name: "Manage Teams", key: "manage_workspace_teams", description: "Create and update teams, including their structure and details" },
      { name: "Workspace Analytics", key: "view_workspace_analytics", description: "View profitability analytics" },
      { name: "Import Timesheet Data", key: "import_timesheets", description: "Bulk-import time entries from a Clockify report, including time logged on behalf of other employees" },
    ],
  },
  {
    module: "Timesheets",
    icon: "clock",
    items: [
      { name: "View Team Timesheets", key: "view_team_timesheets", description: "See the timesheet entries logged by every member of your team" },
      { name: "Edit & Delete Timesheet Entries", key: "manage_timesheet_entries", description: "Correct existing timesheet entries and remove ones that are wrong or no longer needed" },
      { name: "Download Timesheet Data", key: "export_timesheets", description: "Export timesheet records to a downloadable file for reporting, payroll or record-keeping" },
    ],
  },
  {
    module: "HR Letters",
    icon: "mail",
    items: [
      { name: "View HR Letters", key: "view_hr_letters", description: "Open the HR letters area and library" },
      { name: "Generate Letters", key: "generate_letters", description: "Generate letters from templates" },
      { name: "Manage Letter Templates", key: "manage_letter_templates", description: "Create and edit letter templates" },
    ],
  },
  {
    module: "Email Signatures",
    icon: "create",
    items: [
      { name: "Generate Signatures", key: "view_signatures", description: "Create and manage email signatures" },
    ],
  },
  {
    module: "Engagement & Documents",
    icon: "bell",
    items: [
      { name: "Personal Notes", key: "view_notes", description: "Use the personal notes module" },
      { name: "Notifications", key: "view_notifications", description: "View the notifications hub" },
      { name: "View Sign-off Documents", key: "view_signoff", description: "View and acknowledge sign-off documents" },
      { name: "Manage Sign-off Documents", key: "manage_signoff", description: "Upload sign-off documents and view acknowledgements" },
      { name: "Manage Star of the Month", key: "manage_star_of_month", description: "Award and manage Star of the Month" },
      { name: "Manage Newsletters", key: "manage_newsletter", description: "Create, edit and publish newsletters" },
    ],
  },
  {
    module: "Profile Generator",
    icon: "create",
    items: [
      { name: "Profile Generator", key: "view_profile_generator", description: "Create, edit and export branded profile cards" },
      { name: "Manage Profile Assets & Templates", key: "manage_profile_generator", description: "Curate the shared asset library and profile templates" },
    ],
  },
  {
    module: "Appearance",
    icon: "image",
    items: [
      { name: "Dashboard Backgrounds", key: "view_backgrounds", description: "Browse allowed backgrounds, activate one, and upload personal backgrounds" },
      { name: "Manage Background Library", key: "manage_backgrounds", description: "Upload, edit, delete, share library items and set the org default" },
      { name: "Upload Video / GIF & Create Scenes", key: "manage_background_scenes", description: "Upload video and GIF backgrounds, and build layered parallax scenes in the background library" },
    ],
  },
  {
    module: "Administration",
    icon: "settings",
    items: [
      { name: "Company Information", key: "manage_company_info", description: "Edit company details and master data" },
      { name: "Calendar & Shift Settings", key: "manage_calendar_settings", description: "Configure holidays, shifts and attendance rules" },
      { name: "Roles & Access", key: "manage_roles_permissions", description: "Manage roles and their permissions" },
      { name: "Employee Cost", key: "manage_employee_cost", description: "View and manage employee cost data" },
    ],
  },
];

export default permissionsData;
